import React from "react";
import { Link } from "react-scroll";
import "./Home.css";
function Home(){
    return (
        <div id="Home" className="HomeDiv"> 
           <img src="/images/me.jpg" alt="me"/>
           <h1><span>I'm Shaik Roshan Sameer</span>,full stack doveloper</h1>
           <p>Iam a full stack doveloper form tirupati,Iam studing Btech in chittor</p>
           <div className="HomeAction">
           <Link to="Contact" smooth={true} duration={500}>
           <div className="HomeConnect">Connect with me</div>
           </Link>
                <div className="HomeResume"><a download href="/assets/My_Resume.pdf">my resume</a></div>
           </div>
        </div>
    )
}

export default Home;
